import cn from "classnames";

/** Thin border between data rows (first row has no top border). */
const ROW_DIVIDER = "border-t border-greyscale-strength/20";

export function rowDividerClass(isFirstRow: boolean): string {
  return isFirstRow ? "" : ROW_DIVIDER;
}

/** Numeric rating cells (mobile + desktop). */
export const RATING_VALUE_TEXT_CLASS =
  "text-greyscale-body font-normal tabular-nums";

/** Highlight fill + padding for the “featured” brand column (desktop layout only). */
export function desktopColumnHighlightClass(
  columnIndex: number,
  highlightIndex: number,
  rowPosition: "header" | "body" | "last",
): string {
  if (highlightIndex < 0 || columnIndex !== highlightIndex) return "";
  return cn(
    "bg-primary-100 px-2 sm:px-4",
    rowPosition === "header" && "rounded-t-xl",
    rowPosition === "last" && "rounded-b-xl",
  );
}
